export default {
  props: {
    show: Boolean,
    title: String,
    options: {
      type: Array,
      default: () => ([])
    },
    activeIndex: Number,
    onClickItem: Function,
    onClickOverlay: Function,
    renderItem: Function
  },

  render(h) {
    return h('div', {
      class: {
        'a-overlay': true,
        'a-hidden': !this.show
      },
      on: {
        click: this.onClickOverlay,
        touchmove: e => {
          e.preventDefault();
        }
      }
    }, [
      h('div', {
        class: {
          'a-fix-bottom': true,
          'a-modal': true,
          'a-hidden': !this.show
        },
        on: {
          click: e => {
            e.stopPropagation();
          }
        }
      }, [
        h('div', {
          class: "a-modal-head"
        }, this.title),
        h('div', {
          class: "a-modal-body",
          on: {
            touchmove: e => {
              e.stopPropagation();
            }
          }
        }, [
          this.options.map((item, index) => {
            return h('div', {
              key: index, //'index',
              class: {
                'a-option': true,
                'a-checked': index === this.activeIndex,
              },
              on: {
                click: () => {
                  this.onClickItem(index);
                }
              }
            }, [
              h('div', {
                class: "a-option-body"
              }, [
                this.renderItem ? this.renderItem(h, item) : item
              ])
            ]);
          })
        ])
      ])
    ]);
  }
};



// WEBPACK FOOTER //
// ./src/ui/base/components/options.js